import React from 'react';
import { Button, InputNumber, Select, Space } from 'antd';
import { EASING_TYPES } from 'util/constants';
import styles from '../../../event-timeline.module.css';

const { Option } = Select;

interface MoveParamsProps {
  nodeId: string;
  params: any;
  setParams: (params: any) => void;
}

const MoveParams: React.FC<MoveParamsProps> = ({
  nodeId,
  params,
  setParams,
}) => {
  function onSelectPositionPoint() {
    window.dispatchEvent(
      new CustomEvent('add_position_capture_point', {
        detail: {
          nodeId,
          actionName: 'Move Object',
          propertyName: 'New Object position',
          propertyKey: 'position',
        },
      })
    );
  }

  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <h1 className={styles.h1Label}>
          <span>New Object position</span>
          <Button
            className={styles.selectPosButton}
            onClick={onSelectPositionPoint}
          >
            Select Point
          </Button>
        </h1>
        <span className={styles.label}>Position X:</span>
        <InputNumber
          value={params.position?.x || 0}
          onChange={(value) =>
            setParams({
              ...params,
              position: {
                ...params.position,
                x: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span className={styles.label}>Position Y:</span>
        <InputNumber
          value={params.position?.y || 0}
          onChange={(value) =>
            setParams({
              ...params,
              position: {
                ...params.position,
                y: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span className={styles.label}>Position Z:</span>
        <InputNumber
          value={params.position?.z || 0}
          onChange={(value) =>
            setParams({
              ...params,
              position: {
                ...params.position,
                z: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span className={styles.label}>Easing:</span>
        <Select
          value={params.easing || 'linear'}
          onChange={(value) => setParams({ ...params, easing: value })}
          style={{ width: '100%' }}
        >
          <Option value={EASING_TYPES.LINEAR}>Linear</Option>
          <Option value={EASING_TYPES.EASE_IN}>Ease In</Option>
          <Option value={EASING_TYPES.EASE_OUT}>Ease Out</Option>
          <Option value={EASING_TYPES.EASE_IN_OUT}>Ease In Out</Option>
        </Select>
      </Space>
    </div>
  );
};

export default MoveParams;
